import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
// import moment from "moment";
// import ScrollMenu from "react-horizontal-scrolling-menu";
// import parse from "html-react-parser";
// import { FormatColorReset } from "@material-ui/icons";

class InfoLeftTab2 extends PureComponent {
  state = {};
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    this._getData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async () => {
    const { contentSerial } = this.props.childProps;
    // const { existLive } = this.props.childProps;
    const result = await this._getDataApi(contentSerial);
    const intReturn = result.data[0].intReturn;
    const str = result.data[0].str;
    const nextLiveInfo = result.data[0].listData;
    //console.log(contentSerial)
    //console.log(str)
    //console.log(nextLiveInfo)
    //console.log('=====================>다시불러옴.')
    if (this._isMounted) {
      if (intReturn === 0) {
        this.setState({
          str,
          nextLiveInfo,
        });
      } else {
        this.setState({
          str,
        });
      }
    }
  };

  _getDataApi = (contentSerial) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/contentLiveInfo', {
        params: {
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderItem = () => {
    const { nextLiveInfo } = this.state;

    const list = nextLiveInfo.map((item, index) => {
      return (
        <li key={index}>
          <p className="date">
            {item.mm}.{item.dd} ({item.weekName}) {item.startTime}
          </p>
          <p className="epi">{item.subTitle}</p>
        </li>
      );
    });

    return list;
  };

  render() {
    const { str, nextLiveInfo } = this.state;

    return (
      <Fragment>
        <div className="live_list show">
          <div className="tit">본방</div>
          <ul>
            <li>
              <p className="date">{str}</p>
              <p className="epi">
                {/*5화 달 아래에서, 엉터리 댄스를*/}
                {str === '' || str === null || str === undefined
                  ? '편성되지 않았습니다.'
                  : ''}
              </p>
            </li>
          </ul>
        </div>
        <div className="live_list">
          <div className="tit">재방</div>
          <ul>
            {nextLiveInfo ? this._renderItem() : null}
            {/*
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            <li>
                                <p className="date">3.26 (금) 20:30</p>
                                <p className="epi">19화 엘리오르 대삼림의 영구동토</p>
                            </li>
                            */}
          </ul>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(InfoLeftTab2));
